module.exports = __webpack_public_path__ + "img/order_material_to_excel_style4.d9760a36.png";